



const Reasonpicked = ({ data }) => {
    return (
        <>   
            {data.map((each, index) => (
                <div class={`left-section  d-unset d-md-flex p-md-5 p-3 my-0 my-md-5 ${index % 2 == 0 && 'flex-row-reverse'}`} id="partner-section">

                    <div class="partner-image_section  ">
                        <img src={each.Img} width="100% m-0" alt="Your image" />
                    </div>
                    {/* <div className="partner-number">
                       
                    </div> */}
                    <div class={`partner-text pt-5 px-0 px-md-4 ${index % 2 !== 0 && 'partner-text-2'}`} >
                        <p className="partner-heading text-white poppins fs_70 mt-0">{each.heading}</p>
                        <p className="partner-descrption text-white mt-0 fs_19  ls_3">{each.text}</p>

                    </div>
      
                </div>
            ))}
        </>
    )
}
export default Reasonpicked